function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.90566 15.0943H2.64151C2.01628 15.0943 1.50943 14.5875 1.50943 13.9623V2.64151C1.50943 2.01628 2.01628 1.50943 2.64151 1.50943H17.3585C17.9837 1.50943 18.4906 2.01628 18.4906 2.64151V13.9623C18.4906 14.5875 17.9837 15.0943 17.3585 15.0943H9.43396L4.90566 18.4906V15.0943ZM9.93711 16.6038H17.3585C18.8174 16.6038 20 15.4211 20 13.9623V2.64151C20 1.18264 18.8174 0 17.3585 0H2.64151C1.18264 0 0 1.18264 0 2.64151V13.9623C0 15.4211 1.18264 16.6038 2.64151 16.6038H3.39623V18.4906C3.39623 19.0623 3.71925 19.5849 4.23062 19.8406C4.74199 20.0963 5.35394 20.0411 5.81132 19.6981L9.93711 16.6038Z",
  fill: "#757575"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.56604 8.30188C5.56604 7.72876 6.03065 7.26415 6.60377 7.26415C7.1769 7.26415 7.64151 7.72876 7.64151 8.30188C7.64151 8.87501 7.1769 9.33962 6.60377 9.33962C6.03065 9.33962 5.56604 8.87501 5.56604 8.30188Z",
  fill: "#757575"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.96226 8.30188C8.96226 7.72876 9.42687 7.26415 10 7.26415C10.5731 7.26415 11.0377 7.72876 11.0377 8.30188C11.0377 8.87501 10.5731 9.33962 10 9.33962C9.42687 9.33962 8.96226 8.87501 8.96226 8.30188Z",
  fill: "#757575"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3585 8.30188C12.3585 7.72876 12.8231 7.26415 13.3962 7.26415C13.9694 7.26415 14.434 7.72876 14.434 8.30188C14.434 8.87501 13.9694 9.33962 13.3962 9.33962C12.8231 9.33962 12.3585 8.87501 12.3585 8.30188Z",
  fill: "#757575"
});
var SvgBubbleIcon = function SvgBubbleIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBubbleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bubble-icon.9e1e9b22.svg";
export { ForwardRef as ReactComponent };